export default "__VITE_ASSET__CEGv1Ido__"